var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZnanyLekarzLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3945 11.8906L17.3779 16.8867L14.2607 19.165L11.084 15.5176C11.7517 14.022 12.8836 12.7608 14.209 11.834L14.3945 11.8906ZM19.999 8.76562H19.998C14.6016 9.80127 9.81357 13.3613 7.10254 18.166C6.93276 18.467 6.74421 18.841 6.64355 19.1631L2.28613 16.4395C2.15071 16.2386 4.00527 13.6011 4.26953 13.2588C7.76977 8.72307 13.0555 5.64051 18.748 5.03711L19.999 8.76562ZM12.4062 5.9043C9.44096 6.86037 6.60351 8.35705 4.38574 10.5898L0 8.76562L1.20703 5.05957L7.51562 6.45605L8.05273 0H11.9453L12.4062 5.9043Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZnanyLekarzLogo);
export default __webpack_public_path__ + "static/media/znany-lekarz-logo.52fd2cb4552a775b0c23e07df9bb31d1.svg";
export { ForwardRef as ReactComponent };